import { getFolderResourceItems, resourceFolderFileUrl } from './folderResources';

const SEGMENT = 'educators';

/** Files in public/resources/educators/ - add one row per file. */
export const EDUCATOR_RESOURCE_FILES = [
  {
    id: 'isbn-9780674976894-sample',
    title: 'Sample excerpt (9780674976894)',
    description: 'PDF sample for educator use.',
    filename: '9780674976894_sample.pdf',
    icon: '📄',
  },
  {
    id: 'engendering-success-stem-white-papers-2023',
    title: 'Engendering Success in STEM - white papers booklet',
    description: 'White papers booklet (final pages, November 2023).',
    filename: 'BBBB_Engendering-Success-in-STEM_White-Papers-Booklet_Final-Pages-Nov2023.pdf',
    icon: '📄',
  },
  {
    id: 'program-matching-quizzes',
    title: 'Program matching quizzes',
    description:
      'Word document on quizzes that help match learners to programs at their school.',
    filename: 'Program matching quizzes (they recommend programs at that school).docx',
    icon: '📝',
  },
  {
    id: 'the-sponsor-effect',
    title: 'The Sponsor Effect',
    description: 'PDF on sponsorship and career support in professional settings.',
    filename: 'The-Sponsor-Effect.pdf',
    icon: '📄',
  },
];

export function educatorResourceFileUrl(filename) {
  return resourceFolderFileUrl(SEGMENT, filename);
}

export function getEducatorResourceItems() {
  return getFolderResourceItems(SEGMENT, EDUCATOR_RESOURCE_FILES);
}
